(() => {
  const KEY = 'kfaContinueShoppingUrl';
  const sameOrigin = (url) => {
    try { return new URL(url, window.location.origin).origin === window.location.origin; }
    catch (_) { return false; }
  };
  const isProductPath = (path) => /\/products\//.test(path);
  const isCartPath = (path) => /^\/cart(?:\/|$)/.test(path);
  const isUsefulSource = (url) => {
    if (!url || !sameOrigin(url)) return false;
    const parsed = new URL(url, window.location.origin);
    return !isProductPath(parsed.pathname) && !isCartPath(parsed.pathname) && !/^\/checkouts?\//.test(parsed.pathname);
  };
  const store = (url) => {
    if (!isUsefulSource(url)) return;
    const parsed = new URL(url, window.location.origin);
    sessionStorage.setItem(KEY, parsed.pathname + parsed.search + parsed.hash);
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="/products/"]');
    if (!link || isProductPath(window.location.pathname) || isCartPath(window.location.pathname)) return;
    store(window.location.href);
  }, true);

  if (isProductPath(window.location.pathname) && document.referrer) store(document.referrer);
  if (/^\/collections\//.test(window.location.pathname) && !isProductPath(window.location.pathname)) store(window.location.href);

  document.querySelectorAll('[data-kfa-continue-shopping]').forEach((link) => {
    const remembered = sessionStorage.getItem(KEY);
    link.href = remembered && isUsefulSource(remembered) ? remembered : (link.dataset.fallbackUrl || '/');
  });
})();
